import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";

import { Link, useLocation } from "react-router-dom";

// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions";
// reactstrap

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

import logoSm from "../../assets/images/Logo-Braskem.png";
import logoSmLight from "../../assets/images/Logo-Braskem.png";
import logoDark from "../../assets/images/Logo-Braskem.png";
import logoLight from "../../assets/images/Logo-Braskem.png";

//i18n
import { withTranslation } from "react-i18next";

const Header = (props) => {
  
  const location = useLocation();
  const isDocumentCenter = location.pathname === "/document-center";
  
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              {
                props.userRoles === null ? (
                  <div className="logo logo-dark">
                    <span className="logo-sm">
                      <img src={logoSm} alt="" height="30" />
                    </span>
                    <span className="logo-lg">
                      <img src={logoDark} alt="" height="30" />
                    </span>
                  </div>
                ) :(
                  <Link to="/" className="logo logo-dark">
                    <span className="logo-sm">
                      <img src={logoSm} alt="" height="30" />
                    </span>
                    <span className="logo-lg">
                      <img src={logoDark} alt="" height="30" />
                    </span>
                  </Link>
                )
              }
              
              {
                props.userRoles === null ? (
                  <div className="logo logo-light">
                    <span className="logo-sm">
                      <img src={logoSmLight} alt="" height="30" />
                    </span>
                    <span className="logo-lg">
                      <img src={logoLight} alt="" height="30" />
                    </span>
                  </div>
                ) : (
                  <Link to="/" className="logo logo-light">
                    <span className="logo-sm">
                      <img src={logoSmLight} alt="" height="30" />
                    </span>
                    <span className="logo-lg">
                      <img src={logoLight} alt="" height="30" />
                    </span>
                  </Link>
                )
              }
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>

          <div className="d-flex">

            <div className="nav-document-center">
              {!isDocumentCenter && <Link to="/document-center">Go to Document Center</Link>}
            </div>

            <ProfileMenu />

            
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  const { userRoles, loadingRoles } = state.RolesReducer;
  return { layoutType, showRightSidebar, leftMenu, userRoles, loadingRoles };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
